<script lang="ts">
  import { copy } from "../lib/stores/copy";
  import MobilePrizes from "../components/MobilePrizes.svelte";
  import { isPrimaryCampaign } from "../lib/constants/countries";
  import PrizeRewards from "../components/PrizeRewards.svelte";
</script>

<main class="bg-cover bg-no-repeat bg-[center_top] bg-[url('/bg/mobile-bg3.webp')] tabletLg:bg-[url('/bg/primary-bg.webp')] flex-col grow relative bg-dark overflow-y-hidden">
  <div class="flex grow pt-4">
    <div 
      class="flex justify-center tabletLg:flex-row flex-col w-full overflow-y-hidden max-w-[100vw] overflow-x-hidden tabletLg:h-[680px]"
      class:tabletLg:grid={isPrimaryCampaign}
      class:tabletLg:grid-cols-[minmax(450px,1fr)_auto_1fr]={isPrimaryCampaign}
    >
      <PrizeRewards />
      <div
        class="text-center flex flex-row justify-center items-center z-[5]"
        class:tabletLg:col-start-2={isPrimaryCampaign}
        class:mt-8={isPrimaryCampaign}
        class:tabletLg:self-start={isPrimaryCampaign}
        class:tabletLg:h-[420px]={!isPrimaryCampaign}
      >
        <div
          class="p-4 bg-black/50 rounded-md size-max justify-self-center mb-[-10%] tabletLg:mb-0"
          class:my-4={isPrimaryCampaign}
        >
          <h1 class="font-MrEavesXLSanNarOTUltra font-black flex flex-col items-center text-primary whitespace-normal leading-[0.75] uppercase text-shadow mb-[14px] tablet:block tablet:whitespace-nowrap laptop:mb-[20px] {$copy.prizes.mobileTitleClasses} laptop:text-[100px] desktop:text-[110px] desktopLg:text-[120px]">
            {@html $copy.prizes.title}
          </h1>
          <h2 class="font-MrEavesXLSanNarOTUltra text-[19px] leading-[1] uppercase text-white font-black text-shadow mobile:text-[24px] tablet:text-[24px] laptop:text-[29px] desktop:text-[32px] desktopLg:text-[35px]">
            {@html $copy.prizes.subtitle}
          </h2>
        </div>
      </div>
      <MobilePrizes />
    </div>
  </div>
</main>
